
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: '[fxH], cbre-fx-horizontal',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FxHorizontalLayoutComponent {
  @HostBinding('class') fxClass = 'fx--h';
}
